import UserMarker from "./UserMarker";
export function createUserMarker(map, location) {
    var marker = new UserMarker(100, map);
    var position = [location.lng, location.lat];
    map.on('load', function () {
        map.addImage('pulsing-dot', marker, { pixelRatio: 2 });
        map.addSource('dot-point', {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: [
                    {
                        properties: {},
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            'coordinates': position
                        }
                    }
                ]
            }
        });
        map.addLayer({
            id: 'layer-with-pulsing-dot',
            type: 'symbol',
            source: 'dot-point',
            layout: {
                'icon-image': 'pulsing-dot'
            }
        });
    });
}
